import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const NotificationsComponent = React.lazy(() => import("../Components/RootComponents/NotificationsComponent"));
const NotificationsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <NotificationsComponent />
      </Suspense>
    </Fragment>
  );
};

export default NotificationsPage;
